import { render, staticRenderFns } from "./news_view.vue?vue&type=template&id=21bb26e6&scoped=true&"
import script from "./news_view.vue?vue&type=script&lang=js&"
export * from "./news_view.vue?vue&type=script&lang=js&"
import style0 from "./news_view.vue?vue&type=style&index=0&id=21bb26e6&scoped=true&lang=scss&"
import style1 from "./news_view.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bb26e6",
  null
  
)

export default component.exports